"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _formatDateTime = _interopRequireDefault(require("../../../../utils/formatDateTime"));
var _editableField = _interopRequireDefault(require("../../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class UserRoleAssignments extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (value, field) => {
      this.props.onUpdate(this.props.userWithRole.id, field, value);
    });
  }
  render() {
    const userWithRole = this.props.userWithRole;
    return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, userWithRole.email), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "text",
      enabled: true,
      name: "userName",
      value: userWithRole.userName,
      onChange: this._onChange,
      maxLength: 100,
      required: false
    })), /*#__PURE__*/_react.default.createElement("td", null, (0, _formatDateTime.default)(userWithRole.lastLogin)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: true,
      name: "isAdmin",
      checked: userWithRole.isAdmin,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: true,
      name: "isCalendarOfficer",
      checked: userWithRole.isCalendarOfficer,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: true,
      name: "isSafetyOfficer",
      checked: userWithRole.isSafetyOfficer,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: true,
      name: "hasStatsAccess",
      checked: userWithRole.hasStatsAccess,
      onChange: this._onChange
    })));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(UserRoleAssignments, "partialQueries", {
  UsersWithRoles: {
    id: true,
    email: true,
    userName: true,
    lastLogin: true,
    isAdmin: true,
    isCalendarOfficer: true,
    isSafetyOfficer: true,
    hasStatsAccess: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(UserRoleAssignments, undefined, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('User.set', {
      id,
      field,
      value
    });
  }
}));